<template>
  <transition name="subscribe-fade">
  <div class="subscribe-container">
    <div class="subscribe-panel">
      <div id="subscribe-overlay">
        <div id="mc_embed_shell">
          <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css">
          <div id="mc_embed_signup">
            <img id="subscription-cross" @click="toggleSubscribe" src="/issue2/static/_content/subscription-cross.png" />
            <form action="https://kpstudio.us22.list-manage.com/subscribe/post-json?u=1db79021f22160aa6c8eff4de&amp;id=41edb2fc75&amp;f_id=0030c1e1f0&c=?" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
              <div id="mc_embed_signup_scroll">
                <img id="subscription-img" src="/issue2/static/_content/subscription-img.png" />
                <h2 class="sommet-rounded">Stay in the loop!</h2>
                <div class="mc-field-group">
                  <label class="open-sans-regular" for="mce-EMAIL">
                    Enter your email below to receive future issues of <strong class="open-sans-bold">The Loop</strong> direct to your inbox
                  </label>
                  <input type="email" name="EMAIL" class="required email open-sans-regular" id="mce-EMAIL" required="" value="" placeholder="johnsmith@email.com">
                </div>
                <div id="mce-responses" class="clear">
                  <div class="response open-sans-regular" id="mce-error-response" style="display: none;"></div>
                  <div class="response open-sans-regular" id="mce-success-response" style="display: none;">There has been an error, please try again.</div>
                </div>
                <div aria-hidden="true" style="position: absolute; left: -5000px;"><input type="text" name="b_1db79021f22160aa6c8eff4de_41edb2fc75" tabindex="-1" value=""></div>
                <div class="clear"><input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button sommet-rounded" value="Subscribe" onclick="mailChimpSubmit()"></div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>
  </div>
  </transition>
</template>

<script>
import {
  mapState,
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex'
import FeatherIcon from './FeatherIcon.vue'
import TrackingHandler from '../helpers/modules/trackingHandler'
import trackingHandler from '../helpers/modules/trackingHandler';

export default {

  data() {
    return {
    }
  },
  components: {
    FeatherIcon
  },
  computed: {
    ...mapGetters([
      'pages',
      'rightToLeft',
      'basePath'
    ])
  },

  mounted() {
    this.loadScripts()
  },

  methods: {
    ...mapMutations({
      toggleSubscribe: 'TOGGLE_SUBSCRIBE',
    }),
    ...mapActions([
      'goToPage'
    ]),

    loadScripts(){
      this.setMailchimpOne();
      this.setMailchimpTwo();
    },

    setMailchimpOne() {
      var mailchimpValidation = document.createElement('script')
      mailchimpValidation.setAttribute('src', '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js')
      document.head.appendChild(mailchimpValidation)
    },

    setMailchimpTwo(){
      var mailchimpScript = document.createElement("script")
      var inlineScript = 
        document.createTextNode("(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);")
      console.log(inlineScript)
      mailchimpScript.appendChild(inlineScript)
      document.head.appendChild(mailchimpScript)
    }
  }
}
</script>

<style>
  .subscribe-result {
    transition: all .3s ease;
  }

  .subscribe-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    overflow: scroll;
  }

  .subscribe-panel {
    max-width: 1280px;
    margin: auto;
    padding-top: 20px;
    padding-bottom :20px;
  }
  
  .subscribe-close {
    color: #eee;
    float: right;
    outline: none;
  }

  .subscribe-close svg {
    width: 48px;
    height: 48px;
    fill: #00FFB4;
  }

  /* MAILCHIP POP UP STYLING */
  #mc_embed_shell {
    background: #28b1c4;
    clear: left;
    font: 14px Helvetica, Arial, sans-serif;
    max-width: 600px;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    height: 550px;
    width: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #mc_embed_signup {
    display: flex;
    height: 92%;
    width: 92%;
    justify-content: center;
    align-items: center;
    border: 2px solid #ffffff;
    border-radius: 0.3em;
  }

  #mc-embedded-subscribe-form {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80%;
  }

  #mc_embed_signup_scroll {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: space-between;
    height: 100%
  }

  #mc_embed_signup_scroll>h2 {
    text-transform: uppercase;
    font-size: 2.8em !important;
    text-align: center;
    color: #30354b;
  }

  .mc-field-group {
    font-size: 1.1em;
    color: #ffffff;
    width: 90% !important;
    display: flex !important;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .mc-field-group input {
    border: 1px solid #ffffff !important;
    border-radius: 0.9em !important;
    color: #fa8550 !important;
    text-align: center;
  }

  .mc-field-group input::placeholder {
    font-style: italic;
    color: #fa8550 !important;
    font-size: 1em;
  }

  #mc_embed_signup input:focus {
    border: 1px solid #ffffff !important;
    border-radius: 0.9em !important;
  }

  .mc-field-group label {
    width: 80%;
    margin-bottom: 1em !important;
  }

  #mc_embed_signup_scroll>.clear {
    width: 80%;
  }

  .clear>input {
    width: 100% !important;
    background-color: #30354b !important;
    color: #fa8550 !important;
    font-size: 2.5em !important;
    font-weight: bold !important;
    text-align: center;
    height: unset !important;
    padding: 0.5em 0 !important;
    border-radius: 0.6em !important;
    cursor: pointer;
  }

  #subscribe-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  #subscription-img {
    max-width: 100px;
    position: unset !important;
  }

  #subscription-cross {
    max-width: 36px;
    position: absolute;
    top: 10px;
    right: 0.7em;
    cursor: pointer;
  }

  .open-sans-regular {
    font-family: "Open Sans", sans-serif;
    font-optical-sizing: auto;
    font-weight: 300;
    font-style: normal;
    font-variation-settings:
      "wdth" 100;
  }

  .open-sans-bold {
    font-family: "Open Sans", sans-serif;
    font-optical-sizing: auto;
    font-weight: 600;
    font-style: normal;
    font-variation-settings:
      "wdth" 100;
  }

  #mce-responses{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #mce-success-response{
    font-size:0.9em;
    color:white!important;
    width:unset!important;
    padding:0!important;
  }

  #mce-error-response{
    font-size:0.9em;
    color:white!important;
    width:unset!important;
    padding:0!important;
  }

  @font-face {
    font-family: 'SommetRoundedHeavy';
    src: url('/issue2/static/_content/SommetRoundedHeavy.eot?#iefix') format('embedded-opentype'), url('/issue2/static/_content/SommetRoundedHeavy.otf') format('opentype'),
      url('/issue2/static/_content/SommetRoundedHeavy.woff') format('woff'), url('/issue2/static/_content/SommetRoundedHeavy.ttf') format('truetype'), url('/issue2/static/_content/SommetRoundedHeavy.svg#SommetRoundedHeavy') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  .sommet-rounded {
    font-family: 'SommetRoundedHeavy';
  }


</style>


// WEBPACK FOOTER //
// src/components/SubscribePanel.vue